import { getRoute } from '../utils/get-route';
export var getSegmentActionResult = function (router) { return function (name, nodeName) {
    if (nodeName === void 0) { nodeName = ''; }
    var routes = router.getDependencies().routes;
    if (name === nodeName)
        return null;
    var segments = name.split('.');
    var nodeSegments = nodeName.split('.');
    var depth = nodeName === '' ? 1 : nodeSegments.length + 1;
    var segment = segments.slice(0, depth).join('.');
    var route = getRoute(segment, routes);
    return route.actionResult || null;
}; };
